module.exports = __webpack_public_path__ + "static/mailcon-7ede8b2734e560fe141e383ea8083772.jpg";